function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import '../Fieldset/Fieldset.css';
import ThemeContext from '../../ThemeContext';
import cs from 'classnames';
function Radiogroup(_ref) {
  var required = _ref.required,
    readonly = _ref.readonly,
    labelledby = _ref.labelledby,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["required", "readonly", "labelledby", "className", "children"]);
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cs('_dm-fieldset', '_dm-fieldset--unset', "_dm-fieldset--".concat(theme)),
    role: "radiogroup",
    "aria-labelledby": labelledby,
    "aria-required": required,
    "aria-readonly": readonly
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, children));
}

// displayName needs to be explicitly set here so when the code gets mangled
// in production, we can still use this value when checking in other components
Radiogroup.displayName = 'Radiogroup';
export default Radiogroup;